export default {"src":"/_next/static/media/LINK_GREY.61952204.svg","height":12,"width":12,"blurWidth":0,"blurHeight":0};